import * as Yup from "yup";

export const loginSchema = Yup.object({
  email: Yup.string().email("Please enter a valid email").required("Email is required"),
  password: Yup.string().min(6, "Min 6 characters").required("Password is required"),
});

export const userSignupSchema = Yup.object({
 firstName: Yup.string()
  .trim()
  .required("First Name is required")
  .min(2, "First Name must be at least 2 characters")
  .max(30, "First Name cannot exceed 30 characters"),

lastName: Yup.string()
  .trim()
  .required("Last Name is required")
  .min(2, "Last Name must be at least 2 characters")
  .max(30, "Last Name cannot exceed 30 characters"),
  email: Yup.string().email("Please enter a valid email").required("Email is required"),
  password: Yup.string().min(6, "Min 6 characters").required("Password is required"),
  terms: Yup.boolean().oneOf([true], "You must accept the Terms & Conditions"),
  isUpdateReceive: Yup.boolean(), // optional
});

export const vendorSignupSchema = Yup.object({
 firstName: Yup.string()
  .trim()
  .required("First Name is required")
  .min(2, "First Name must be at least 2 characters")
  .max(30, "First Name cannot exceed 30 characters"),

lastName: Yup.string()
  .trim()
  .required("Last Name is required")
  .min(2, "Last Name must be at least 2 characters")
  .max(30, "Last Name cannot exceed 30 characters"),
  email: Yup.string().email("Please enter a valid email").required("Email is required"),
  password: Yup.string().min(6, "Min 6 characters").required("Password is required"),
  companyName: Yup.string(). trim().required("Company Name is required").min(2, "Company Name must be at least 2 characters").max(30, "Company name cannot exceed 30 characters"),
  companyEmail: Yup.string().email("Please enter a valid email").required("Company Email is required"),
  industry: Yup.string().required("Industry is required"),
  companySize: Yup.string().required("Company Size is required"),
  terms: Yup.boolean().oneOf([true], "You must accept the Terms & Conditions"),
  isUpdateReceive: Yup.boolean(), // optional
});

export const forgotPasswordSchema = Yup.object({
  email: Yup.string().email("Please enter a valid email").required("Email is required"),
});

export const resetPasswordSchema = Yup.object().shape({
  password: Yup
    .string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters"),
    
  confirmPassword: Yup
    .string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("password")], "Passwords must match"),
});